import { ImpactDownIcon, TrendIcon } from '../../foundations';

import type { ReactNode } from 'react';

import type { TrendMarkerVariantType } from './trend-marker.types';

export const POSITIVE_SIGN = '+';
export const NEGATIVE_SIGN = '-';
export const TEST_ID_TREND_ICON = 'trend-icon';
export const TEST_ID_IMPACT_DOWN_ICON = 'impact-down-icon';

export const TREND_MARKER = {
  NEGATIVE: 'negative',
  NEUTRAL: 'neutral',
  POSITIVE: 'positive',
} as const;

export const TREND_MARKER_VARIANTS: {
  [key in TrendMarkerVariantType]: {
    defaultIcon: ReactNode;
    sign: null | string;
    trendClass: string;
  };
} = {
  [TREND_MARKER.NEGATIVE]: {
    defaultIcon: <ImpactDownIcon data-testid={TEST_ID_IMPACT_DOWN_ICON} size={16} />,
    sign: NEGATIVE_SIGN,
    trendClass: 'rbui-trend-marker--negative',
  },
  [TREND_MARKER.NEUTRAL]: {
    defaultIcon: null,
    sign: null,
    trendClass: 'rbui-trend-marker--neutral',
  },
  [TREND_MARKER.POSITIVE]: {
    defaultIcon: <TrendIcon data-testid={TEST_ID_TREND_ICON} size={16} />,
    sign: POSITIVE_SIGN,
    trendClass: 'rbui-trend-marker--positive',
  },
};

export const getTrendIcon = (useIcon: boolean | ReactNode, defaultIcon: ReactNode): ReactNode => {
  if (!useIcon) {
    return null;
  }
  if (useIcon === true) {
    return defaultIcon;
  }
  return useIcon;
};
